import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoftphoneDialpadComponent } from './softphone-dialpad/softphone-dialpad.component';
import { SoftphoneMenuComponent } from './softphone-menu/softphone-menu.component';
import { SoftphoneTransferComponent } from './softphone-transfer/softphone-transfer.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { TruncateModule } from 'app/pipes/truncate/truncate-pipe.module';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
    declarations: [
        SoftphoneDialpadComponent,
        SoftphoneMenuComponent,
        SoftphoneTransferComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatGridListModule,
        MatBottomSheetModule,
        MatIconModule,
        MatFormFieldModule,
        MatCardModule,
        MatDividerModule,
        MatListModule,
        MatMenuModule,
        MatInputModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        FormsModule,
        FormlyMaterialModule,
        FormlyModule,
        MatTableModule,
        TruncateModule,
        MatTooltipModule
    ],
    exports: [
        SoftphoneMenuComponent,
    ]
})
export class SoftphoneMenuModule { }
